import React, {useState, useEffect}  from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Link
} from "react-router-dom";

import PhoneTotal from './components/PhoneTotal.jsx'

import CalendarView from './components/CalendarView'

// User Logger
import { UserLog } from  './components/UserActivityLogger'



export default function App() {

	// return 	<>
	// 		{/*<TagsTerrain  />*/}
	// 		<TagDayLoop  />
	//     </>

	UserLog({started: 'app'})

	return (
	<BrowserRouter>  	
  		<div id="app-wrap">
  			<aside>
	  			<nav>
	  				<Link to="/phone">Phone</Link>
	  				<Link to="/calendar">Calendar</Link>
	  				{/*<Link to="/useractshape">User Vis</Link>*/}
  				</nav>
  			</aside>
  			<main>
	  			<Routes>
	  				<Route
		  				path="/phone"
		  				element={<PhoneTotal />}
	  				/>
	  				<Route
		  				path="/calendar"
		  				element={<CalendarView />}
	  				/>
	  				{/*
	  				<Route
		  				path="/useractshape"
		  				element={<UserActShape />}
	  				/>
	  				*/}
  				</Routes>
			</main>
		</div>
	</BrowserRouter>  	
  );

}